module.exports = __webpack_public_path__ + "img/ic_feature_training.77584d55.svg";